
import ManageUsers from "../components/superadmin/ManageUsers";

export default function SuperUsers() {
  return (
    <div>
      <ManageUsers />
    </div>
  );
}
